import { render, staticRenderFns } from "./PersonnalConfigOf.vue?vue&type=template&id=2e5aeaaf&scoped=true&"
import script from "./PersonnalConfigOf.vue?vue&type=script&lang=js&"
export * from "./PersonnalConfigOf.vue?vue&type=script&lang=js&"
import style0 from "./PersonnalConfigOf.vue?vue&type=style&index=0&id=2e5aeaaf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5aeaaf",
  null
  
)

component.options.__file = "PersonnalConfigOf.vue"
export default component.exports